export const maskedCpf = (cpf) => {
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2') //Coloca um ponto entre o terceiro e o quarto dígitos
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2') //Coloca um ponto entre o terceiro e o quarto dígitos de novo (para o segundo bloco de números)
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2') //Coloca um hífen entre o terceiro e o quarto dígitos
  return cpf
}

export const maskedCnpj = (cnpj) => {
  cnpj = cnpj
    .toUpperCase() // Converte todas as letras para maiúsculo
    .replace(/[^A-Z0-9]/g, '') // Remove qualquer caractere que não seja letra ou número
    .slice(0, 14) // Limita o tamanho máximo em 14 caracteres

  cnpj = cnpj.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2') // Adiciona um ponto após os 2 primeiros caracteres
  cnpj = cnpj.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3') // Adiciona um segundo ponto após os próximos 3 caracteres
  cnpj = cnpj.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2') // Adiciona uma barra após o bloco de 3 caracteres
  cnpj = cnpj.replace(/([A-Z0-9]{4})(\d{1,2})$/, '$1-$2') // Adiciona um hífen antes dos 2 dígitos verificadores finais
  return cnpj
}
